// import { Add, ArrowBackOutlined, ArrowForwardOutlined, Cancel, Close, DeleteOutlineOutlined, EditOutlined } from '@mui/icons-material';
// import { Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, TextField, Typography } from '@mui/material'
// import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
// import { ApiCreateAddress, ApiDeleteAddress, ApiGetAddress, ApiUpdateAddress } from '../../../Core/Apicall';
// import { toast } from 'react-toastify';
// import { useDispatch, useSelector } from 'react-redux';
// import { RootState } from '../../../Redux/store';
// import { setActiveCartStep, setSelectedDeliveryAddress } from '../../../Redux/Reducers/globalSlice';
// import { AddressInterface } from '../../../types/Address';
// import { useFormik } from 'formik';
// import * as Yup from "yup";
// import OrderSummary from './OrderSummary';


// interface AddressFormValues {
//     contactPerson: string;
//     mobileNumber: string;
//     addressLine1: string;
//     addressLine2: string;
//     city: string;
//     state: string;
//     country: string;
//     postalCode: string;
//     isDefault: boolean;
// }


// function Address() {
//     const [allAddress, setAllAddress] = useState<AddressInterface[]>([])
//     const [selectedAddress, setSelectedAddress] = useState<AddressInterface | null>()
//     const { cartlist, activeCartStep, selectedDeliveryAddress } = useSelector((state: RootState) => state.global)
//     const [editAddress, setEditAddress] = useState<AddressInterface | null>()
//     const [openAddressDialog, setOpenAddressDialog] = useState(false);
//     const dispatch = useDispatch()
//     const getProceedNextButton = () => {
//         return (
//             <Box className='d-flex align-items-center justify-content-end'>
//                 <Button className='btn-main px-3' onClick={() => { dispatch(setActiveCartStep(activeCartStep + 1)) }}>Review Order&nbsp;<ArrowForwardOutlined /></Button>
//             </Box>
//         )
//     }
//     const getProceedPreviousButton = () => {
//         return (
//             <Box className='d-flex align-items-center justify-content-end'>
//                 <Button className='btn-outlined-main px-3 py-1' onClick={() => { dispatch(setActiveCartStep(activeCartStep - 1)) }}><ArrowBackOutlined />&nbsp;Previous</Button>
//             </Box>
//         )
//     }
//     const GetAddress = async () => {
//         try {
//             const data = `?addressType=SHIPPING`
//             const res = await ApiGetAddress(data)
//             if (res?.status) {
//                 setAllAddress(res?.data)
//                 dispatch(setSelectedDeliveryAddress(res?.data?.find((item: AddressInterface) => item?.isDefault)))
//             }
//         } catch (error: any) {
//             console.log("Error", error)
//             toast.error(error?.message || "Something went wrong");
//         }
//     }


//     useEffect(() => {
//         GetAddress()
//     }, [])


//     const formik = useFormik<AddressFormValues>({
//         initialValues: {
//             contactPerson: editAddress?.contactPerson || "",
//             mobileNumber: editAddress?.mobileNumber || "",
//             addressLine1: `${editAddress?.addressLine1}${editAddress?.addressLine2}` || "",
//             addressLine2: "",
//             city: editAddress?.city || "",
//             state: editAddress?.state || "",
//             country: editAddress?.country || "",
//             postalCode: editAddress?.postalCode || "",
//             isDefault: false,
//         },

//         validationSchema: Yup.object({
//             contactPerson: Yup.string()
//                 .trim()
//                 .required("Contact person is required"),

//             mobileNumber: Yup.string()
//                 .matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number")
//                 .required("Mobile number is required"),

//             addressLine1: Yup.string()
//                 .trim()
//                 .required("Address is required"),

//             city: Yup.string()
//                 .trim()
//                 .required("City is required"),

//             state: Yup.string()
//                 .trim()
//                 .required("State is required"),

//             country: Yup.string()
//                 .trim()
//                 .required("Country is required"),

//             postalCode: Yup.string()
//                 .matches(/^[0-9]{5,6}$/, "Enter a valid postal code")
//                 .required("Postal code is required"),

//             isDefault: Yup.boolean(),
//         }),

//         onSubmit: async (values) => {
//             try {
//                 const params = `?addressId=${editAddress?.addressId}`
//                 const data = {
//                     ...values,
//                     "addressType": "SHIPPING"
//                 }
//                 const res = editAddress?.addressId ? await ApiUpdateAddress(params, data) : await ApiCreateAddress(data)
//                 if (res?.status) {
//                     formik.resetForm();
//                     setEditAddress(null)
//                     GetAddress()
//                     setOpenAddressDialog(false)
//                 }
//             } catch (error: any) {
//                 toast.error(error?.message || "Something went wrong");
//             }
//         },
//         enableReinitialize: true
//     });

//     const handleClose = () => {
//         formik.resetForm();
//         setOpenAddressDialog(false)
//     };

//     const deleteAddress = async (addressId: number) => {
//         const isConfirm = window?.confirm("Are you sure you want to delete this address ?")
//         if (isConfirm) {
//             try {
//                 const data = `?addressId=${addressId}`
//                 const res = await ApiDeleteAddress(data)
//                 if (res?.status) {
//                     GetAddress()
//                 }
//             } catch (error: any) {
//                 toast.error(error?.message || "Something went wrong");
//             }
//         }
//         else {
//             return
//         }
//     }


//     useEffect(()=>{
//         setSelectedAddress(selectedDeliveryAddress);
//     },[selectedDeliveryAddress])
//     return (
//         <Box>
//             <Box>
//                 <Typography variant='body2' className='text-main fw-bold' gutterBottom>step 2 of 4</Typography>
//                 <Typography variant='h5' className='fw-bold'>Delivery Address</Typography>
//                 <Typography variant='body2' className='text-grey' sx={{ letterSpacing: '1px' }}>Select an existing address or add a new delivery address.</Typography>

//             </Box>
//             <Grid className='mt-3' container spacing={1} sx={{ alignItems: 'start' }}>
//                 <Grid size={{ xs: 12, md: 'grow' }} className='border bg-white border-10 p-3'>
//                     <Box className='d-flex align-items-center justify-content-between'>
//                         <Typography variant='h6' className='fw-bold' gutterBottom>Saved Address</Typography>
//                         <Box onClick={() => { setOpenAddressDialog(true) }} className='d-flex pointer align-items-center gap-1 text-dark-main fw-bold'><Add /><Typography>Add New Address</Typography></Box>
//                     </Box>
//                     <Box className='mt-2'>
//                         {allAddress?.map((address: AddressInterface) => {
//                             const isSelected =
//                                 selectedAddress?.addressId === address?.addressId;
//                             return (
//                                 <Box onClick={() => dispatch(setSelectedDeliveryAddress(address))} className='mb-2 border-10 p-3 d-flex align-items-start justify-content-between gap-3'
//                                     sx={{
//                                         cursor: 'pointer',
//                                         backgroundColor: isSelected
//                                             ? 'var(--primary-light-color)'
//                                             : 'white',
//                                         border: isSelected
//                                             ? '1px solid var(--primary-color)'
//                                             : '1px solid #dee2e6',
//                                         transition: 'all 0.2s ease',
//                                     }}
//                                 >
//                                     <Box sx={{ flex: 1 }}>
//                                         <Box className='d-flex align-items-center gap-2 mb-2'>
//                                             <Typography variant='body1' className='fw-bold'>{address?.contactPerson}</Typography>
//                                             {address?.isDefault && (<Chip
//                                                 label="Default"
//                                                 className='m-0 text-white'
//                                                 sx={{ height: 'auto', background: "var(--primary-dark-color)", padding: '2px 3px' }}
//                                             ></Chip>)}
//                                         </Box>
//                                         <Typography variant='body2' className='text-grey'>{address?.addressLine1}</Typography>
//                                         <Typography variant='body2' className='text-grey'>{address?.addressLine2}</Typography>
//                                         <Typography variant='body2' className='text-grey'>{address?.city},{address?.state}-{address?.postalCode},{address?.country}</Typography>
//                                         <Typography variant='body2' className='text-grey'>{address?.mobileNumber}</Typography>
//                                     </Box>
//                                     <Box className='d-flex align-items-center gap-2'>
//                                         <IconButton className='m-0 p-0' onClick={(e) => { e.stopPropagation(); setEditAddress(address); setOpenAddressDialog(true) }}><EditOutlined className='text-main' /></IconButton>
//                                         <IconButton className='m-0 p-0' onClick={(e) => { e.stopPropagation(); deleteAddress(address?.addressId) }}><DeleteOutlineOutlined className='text-danger' /></IconButton>
//                                     </Box>
//                                 </Box>
//                             )
//                         })}
//                     </Box>
//                     <Box className='d-flex align-items-center justify-content-between'>
//                         {getProceedPreviousButton()}
//                         {getProceedNextButton()}
//                     </Box>
//                 </Grid>
//                 <Grid className='d-none d-md-inline-block' size={{ xs: 12, md: 4, xl: 3 }}>
//                     <OrderSummary />
//                 </Grid>
//             </Grid>


//             <Dialog
//                 open={openAddressDialog}
//                 // onClose={handleClose}
//                 fullWidth
//                 maxWidth="sm"
//             >
//                 <Box className='d-flex align-items-center justify-content-between'>
//                     <DialogTitle>
//                         Add Delivery Address
//                     </DialogTitle>
//                     <DialogActions>
//                         <IconButton onClick={handleClose}>
//                             <Close />
//                         </IconButton>
//                     </DialogActions>
//                 </Box>

//                 <Box component="form" onSubmit={formik.handleSubmit}>
//                     <DialogContent>
//                         <Grid container spacing={2}>
//                             {/* Contact Person */}
//                             <Grid size={{ xs: 12, sm: 6 }}>
//                                 <Typography className='fw-bold input-label' variant='body2' gutterBottom>Contact Person</Typography>
//                                 <TextField
//                                     fullWidth
//                                     size="small"
//                                     placeholder="Contact Person"
//                                     name="contactPerson"
//                                     value={formik.values.contactPerson}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                     error={
//                                         formik.touched.contactPerson &&
//                                         Boolean(formik.errors.contactPerson)
//                                     }
//                                     helperText={
//                                         formik.touched.contactPerson &&
//                                         formik.errors.contactPerson
//                                     }
//                                 />
//                             </Grid>

//                             {/* Mobile Number */}
//                             <Grid size={{ xs: 12, sm: 6 }}>
//                                 <Typography className='fw-bold input-label' variant='body2' gutterBottom>Mobile Number</Typography>
//                                 <TextField
//                                     fullWidth
//                                     size="small"
//                                     placeholder="Mobile Number"
//                                     name="mobileNumber"
//                                     value={formik.values.mobileNumber}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                     slotProps={{
//                                         htmlInput: {
//                                             maxLength: 10,
//                                         },
//                                     }}
//                                     error={
//                                         formik.touched.mobileNumber &&
//                                         Boolean(formik.errors.mobileNumber)
//                                     }
//                                     helperText={
//                                         formik.touched.mobileNumber &&
//                                         formik.errors.mobileNumber
//                                     }
//                                 />
//                             </Grid>

//                             {/* Address */}
//                             <Grid size={{ xs: 12 }}>
//                                 <Typography className='fw-bold input-label' variant='body2' gutterBottom>Address</Typography>
//                                 <TextField
//                                     fullWidth
//                                     size="small"
//                                     placeholder="Address"
//                                     name="addressLine1"
//                                     value={formik.values.addressLine1}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                     multiline
//                                     rows={2}
//                                     error={
//                                         formik.touched.addressLine1 &&
//                                         Boolean(formik.errors.addressLine1)
//                                     }
//                                     helperText={
//                                         formik.touched.addressLine1 &&
//                                         formik.errors.addressLine1
//                                     }
//                                 />
//                             </Grid>

//                             {/* City */}
//                             <Grid size={{ xs: 12, sm: 6 }}>
//                                 <Typography className='fw-bold input-label' variant='body2' gutterBottom>City</Typography>
//                                 <TextField
//                                     fullWidth
//                                     size="small"
//                                     placeholder="City"
//                                     name="city"
//                                     value={formik.values.city}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                     error={
//                                         formik.touched.city &&
//                                         Boolean(formik.errors.city)
//                                     }
//                                     helperText={
//                                         formik.touched.city &&
//                                         formik.errors.city
//                                     }
//                                 />
//                             </Grid>

//                             {/* State */}
//                             <Grid size={{ xs: 12, sm: 6 }}>
//                                 <Typography className='fw-bold input-label' variant='body2' gutterBottom>State</Typography>
//                                 <TextField
//                                     fullWidth
//                                     size="small"
//                                     placeholder="State"
//                                     name="state"
//                                     value={formik.values.state}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                     error={
//                                         formik.touched.state &&
//                                         Boolean(formik.errors.state)
//                                     }
//                                     helperText={
//                                         formik.touched.state &&
//                                         formik.errors.state
//                                     }
//                                 />
//                             </Grid>

//                             {/* Country */}
//                             <Grid size={{ xs: 12, sm: 6 }}>
//                                 <Typography className='fw-bold input-label' variant='body2' gutterBottom>Country</Typography>
//                                 <TextField
//                                     fullWidth
//                                     size="small"
//                                     placeholder="Country"
//                                     name="country"
//                                     value={formik.values.country}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                     error={
//                                         formik.touched.country &&
//                                         Boolean(formik.errors.country)
//                                     }
//                                     helperText={
//                                         formik.touched.country &&
//                                         formik.errors.country
//                                     }
//                                 />
//                             </Grid>

//                             {/* Postal Code */}
//                             <Grid size={{ xs: 12, sm: 6 }}>
//                                 <Typography className='fw-bold input-label' variant='body2' gutterBottom>Postal Code</Typography>
//                                 <TextField
//                                     fullWidth
//                                     size="small"
//                                     placeholder="Postal Code"
//                                     name="postalCode"
//                                     value={formik.values.postalCode}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                     slotProps={{
//                                         htmlInput: {
//                                             maxLength: 6,
//                                         },
//                                     }}
//                                     error={
//                                         formik.touched.postalCode &&
//                                         Boolean(formik.errors.postalCode)
//                                     }
//                                     helperText={
//                                         formik.touched.postalCode &&
//                                         formik.errors.postalCode
//                                     }
//                                 />
//                             </Grid>

//                             {/* Default Address */}
//                             <Grid size={{ xs: 12 }}>
//                                 <FormControlLabel
//                                     control={
//                                         <Checkbox
//                                             name="isDefault"
//                                             checked={formik.values.isDefault}
//                                             onChange={formik.handleChange}
//                                         />
//                                     }
//                                     label="Set as default address"
//                                 />
//                             </Grid>

//                         </Grid>
//                     </DialogContent>

//                     <DialogActions sx={{ px: 3, pb: 2 }}>
//                         <Button
//                             variant="outlined"
//                             onClick={handleClose}
//                             className='btn-outlined-main'
//                         >
//                             Cancel
//                         </Button>

//                         <Button
//                             type="submit"
//                             className='btn-main px-3'
//                         >
//                             Save Address
//                         </Button>
//                     </DialogActions>
//                 </Box>
//             </Dialog>

//         </Box>
//     )
// }

// export default Address


import { Add, ArrowBackOutlined, ArrowForwardOutlined, Close, DeleteOutlineOutlined, EditOutlined } from '@mui/icons-material';
import { Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Grid, IconButton, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ApiCreateAddress, ApiDeleteAddress, ApiGetAddress, ApiUpdateAddress } from '../../../Core/Apicall';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../Redux/store';
import {
    setActiveCartStep,
    setSelectedDeliveryAddress,
    setSelectedBillingAddress,
    setBillingSameAsDelivery,
} from '../../../Redux/Reducers/globalSlice';
import { AddressInterface } from '../../../types/Address';
import { useFormik } from 'formik';
import * as Yup from "yup";
import OrderSummary from './OrderSummary';

type AddressType = 'SHIPPING' | 'BILLING';

interface AddressFormValues {
    contactPerson: string;
    mobileNumber: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    country: string;
    postalCode: string;
    isDefault: boolean;
}

function Address() {
    const [deliveryAddresses, setDeliveryAddresses] = useState<AddressInterface[]>([])
    const [billingAddresses, setBillingAddresses] = useState<AddressInterface[]>([])
    const [editAddress, setEditAddress] = useState<AddressInterface | null>(null)
    const [openAddressDialog, setOpenAddressDialog] = useState(false);
    // which list the dialog is currently adding / editing for
    const [dialogType, setDialogType] = useState<AddressType>('SHIPPING');

    const {
        activeCartStep,
        selectedDeliveryAddress,
        selectedBillingAddress,
        billingSameAsDelivery,
    } = useSelector((state: RootState) => state.global)
    const dispatch = useDispatch()

    /* ------------------------------ navigation ------------------------------ */

    const handleNext = () => {
        if (!selectedDeliveryAddress) {
            toast.error("Please select a delivery address");
            return;
        }
        if (!billingSameAsDelivery && !selectedBillingAddress) {
            toast.error("Please select or add a billing address");
            return;
        }
        dispatch(setActiveCartStep(activeCartStep + 1))
    }

    const getProceedNextButton = () => (
        <Box className='d-flex align-items-center justify-content-end'>
            <Button className='btn-main px-3' onClick={handleNext}>Review Order&nbsp;<ArrowForwardOutlined /></Button>
        </Box>
    )

    const getProceedPreviousButton = () => (
        <Box className='d-flex align-items-center justify-content-end'>
            <Button className='btn-outlined-main px-3 py-1' onClick={() => { dispatch(setActiveCartStep(activeCartStep - 1)) }}><ArrowBackOutlined />&nbsp;Previous</Button>
        </Box>
    )

    /* ------------------------------ data loading ----------------------------- */

    // Keeps the current selection if it still exists (picks up edited values), otherwise falls back to default.
    const resolveSelection = (list: AddressInterface[], current?: AddressInterface | null) =>
        list.find((a) => a.addressId === current?.addressId) || list.find((a) => a.isDefault) || null;

    const fetchAddresses = async (type: AddressType) => {
        try {
            const res = await ApiGetAddress(`?addressType=${type}`)
            if (!res?.status) return
            const list: AddressInterface[] = res?.data || []
            if (type === 'SHIPPING') {
                setDeliveryAddresses(list)
                dispatch(setSelectedDeliveryAddress(resolveSelection(list, selectedDeliveryAddress)))
            } else {
                setBillingAddresses(list)
                if (!billingSameAsDelivery) {
                    dispatch(setSelectedBillingAddress(resolveSelection(list, selectedBillingAddress)))
                }
            }
        } catch (error: any) {
            console.log("Error", error)
            toast.error(error?.message || "Something went wrong");
        }
    }

    useEffect(() => {
        fetchAddresses('SHIPPING')
        fetchAddresses('BILLING')
    }, [])

    // When "same as delivery" is ticked, billing address always mirrors the selected delivery address.
    useEffect(() => {
        if (billingSameAsDelivery) {
            dispatch(setSelectedBillingAddress(selectedDeliveryAddress || null))
        }
    }, [billingSameAsDelivery, selectedDeliveryAddress])

    const handleSameAsDeliveryChange = (checked: boolean) => {
        dispatch(setBillingSameAsDelivery(checked))
        if (checked) {
            dispatch(setSelectedBillingAddress(selectedDeliveryAddress || null))
        } else {
            // switch to a saved billing address (default) or force the user to pick / add one
            dispatch(setSelectedBillingAddress(resolveSelection(billingAddresses, null)))
        }
    }

    /* --------------------------------- form --------------------------------- */

    const formik = useFormik<AddressFormValues>({
        initialValues: {
            contactPerson: editAddress?.contactPerson || "",
            mobileNumber: editAddress?.mobileNumber || "",
            addressLine1: [editAddress?.addressLine1, editAddress?.addressLine2].filter(Boolean).join(", "),
            addressLine2: "",
            city: editAddress?.city || "",
            state: editAddress?.state || "",
            country: editAddress?.country || "",
            postalCode: editAddress?.postalCode || "",
            isDefault: editAddress?.isDefault || false,
        },

        validationSchema: Yup.object({
            contactPerson: Yup.string().trim().required("Contact person is required"),
            mobileNumber: Yup.string()
                .matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number")
                .required("Mobile number is required"),
            addressLine1: Yup.string().trim().required("Address is required"),
            city: Yup.string().trim().required("City is required"),
            state: Yup.string().trim().required("State is required"),
            country: Yup.string().trim().required("Country is required"),
            postalCode: Yup.string()
                .matches(/^[0-9]{5,6}$/, "Enter a valid postal code")
                .required("Postal code is required"),
            isDefault: Yup.boolean(),
        }),

        onSubmit: async (values) => {
            try {
                const params = `?addressId=${editAddress?.addressId}`
                const data = { ...values, addressType: dialogType }
                const res = editAddress?.addressId ? await ApiUpdateAddress(params, data) : await ApiCreateAddress(data)
                if (res?.status) {
                    const type = dialogType
                    formik.resetForm();
                    setEditAddress(null)
                    setOpenAddressDialog(false)
                    fetchAddresses(type)
                }
            } catch (error: any) {
                toast.error(error?.message || "Something went wrong");
            }
        },
        enableReinitialize: true
    });

    const openDialog = (type: AddressType, address: AddressInterface | null = null) => {
        setDialogType(type)
        setEditAddress(address)
        setOpenAddressDialog(true)
    }

    const handleClose = () => {
        formik.resetForm();
        setEditAddress(null)
        setOpenAddressDialog(false)
    };

    const deleteAddress = async (addressId: number, type: AddressType) => {
        const isConfirm = window?.confirm("Are you sure you want to delete this address ?")
        if (!isConfirm) return
        try {
            const res = await ApiDeleteAddress(`?addressId=${addressId}`)
            if (res?.status) {
                fetchAddresses(type)
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong");
        }
    }

    /* -------------------------------- rendering ------------------------------ */

    const renderAddressCard = (address: AddressInterface, type: AddressType) => {
        const selected = type === 'SHIPPING' ? selectedDeliveryAddress : selectedBillingAddress
        const isSelected = selected?.addressId === address?.addressId;
        const onSelect = () =>
            dispatch(type === 'SHIPPING' ? setSelectedDeliveryAddress(address) : setSelectedBillingAddress(address))

        return (
            <Box
                key={`${type}-${address?.addressId}`}
                onClick={onSelect}
                className='mb-2 border-10 p-3 d-flex align-items-start justify-content-between gap-3'
                sx={{
                    cursor: 'pointer',
                    backgroundColor: isSelected ? 'var(--primary-light-color)' : 'white',
                    border: isSelected ? '1px solid var(--primary-color)' : '1px solid #dee2e6',
                    transition: 'all 0.2s ease',
                }}
            >
                <Box sx={{ flex: 1 }}>
                    <Box className='d-flex align-items-center gap-2 mb-2'>
                        <Typography variant='body1' className='fw-bold'>{address?.contactPerson}</Typography>
                        {address?.isDefault && (
                            <Chip
                                label="Default"
                                className='m-0 text-white'
                                sx={{ height: 'auto', background: "var(--primary-dark-color)", padding: '2px 3px' }}
                            />
                        )}
                    </Box>
                    <Typography variant='body2' className='text-grey'>{address?.addressLine1}</Typography>
                    <Typography variant='body2' className='text-grey'>{address?.addressLine2}</Typography>
                    <Typography variant='body2' className='text-grey'>{address?.city},{address?.state}-{address?.postalCode},{address?.country}</Typography>
                    <Typography variant='body2' className='text-grey'>{address?.mobileNumber}</Typography>
                </Box>
                <Box className='d-flex align-items-center gap-2'>
                    <IconButton className='m-0 p-0' onClick={(e) => { e.stopPropagation(); openDialog(type, address) }}><EditOutlined className='text-main' /></IconButton>
                    <IconButton className='m-0 p-0' onClick={(e) => { e.stopPropagation(); deleteAddress(address?.addressId, type) }}><DeleteOutlineOutlined className='text-danger' /></IconButton>
                </Box>
            </Box>
        )
    }

    const renderTextField = (name: keyof AddressFormValues, label: string, extra: object = {}) => (
        <TextField
            fullWidth
            size="small"
            placeholder={label}
            name={name}
            value={formik.values[name] as string}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={Boolean(formik.touched[name] && formik.errors[name])}
            helperText={formik.touched[name] && formik.errors[name]}
            {...extra}
        />
    )

    const addressTypeLabel = dialogType === 'SHIPPING' ? 'Delivery' : 'Billing'

    return (
        <Box>
            <Box>
                <Typography variant='body2' className='text-main fw-bold' gutterBottom>step 2 of 4</Typography>
                <Typography variant='h5' className='fw-bold'>Delivery &amp; Billing Address</Typography>
                <Typography variant='body2' className='text-grey' sx={{ letterSpacing: '1px' }}>Select an existing address or add a new one.</Typography>
            </Box>

            <Grid className='mt-3' container spacing={1} sx={{ alignItems: 'start' }}>
                <Grid size={{ xs: 12, md: 'grow' }} className='border bg-white border-10 p-3'>

                    {/* ------------------------- Delivery address ------------------------- */}
                    <Box className='d-flex align-items-center justify-content-between'>
                        <Typography variant='h6' className='fw-bold' gutterBottom>Delivery Address</Typography>
                        <Box onClick={() => openDialog('SHIPPING')} className='d-flex pointer align-items-center gap-1 text-dark-main fw-bold'><Add /><Typography>Add New Address</Typography></Box>
                    </Box>
                    <Box className='mt-2'>
                        {deliveryAddresses?.map((address) => renderAddressCard(address, 'SHIPPING'))}
                    </Box>

                    <Divider className='my-3' />

                    {/* -------------------------- Billing address ------------------------- */}
                    <Box className='d-flex align-items-center justify-content-between'>
                        <Typography variant='h6' className='fw-bold' gutterBottom>Billing Address</Typography>
                        {!billingSameAsDelivery && (
                            <Box onClick={() => openDialog('BILLING')} className='d-flex pointer align-items-center gap-1 text-dark-main fw-bold'><Add /><Typography>Add New Address</Typography></Box>
                        )}
                    </Box>

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={billingSameAsDelivery}
                                onChange={(e) => handleSameAsDeliveryChange(e.target.checked)}
                            />
                        }
                        label="Billing address is same as delivery address"
                    />

                    {!billingSameAsDelivery && (
                        <Box className='mt-2'>
                            {billingAddresses?.length ? (
                                billingAddresses.map((address) => renderAddressCard(address, 'BILLING'))
                            ) : (
                                <Typography variant='body2' className='text-grey'>No saved billing address. Add a new one to continue.</Typography>
                            )}
                        </Box>
                    )}

                    <Box className='mt-3 d-flex align-items-center justify-content-between'>
                        {getProceedPreviousButton()}
                        {getProceedNextButton()}
                    </Box>
                </Grid>

                <Grid className='d-none d-md-inline-block' size={{ xs: 12, md: 4, xl: 3 }}>
                    <OrderSummary />
                </Grid>
            </Grid>

            <Dialog open={openAddressDialog} fullWidth maxWidth="sm">
                <Box className='d-flex align-items-center justify-content-between'>
                    <DialogTitle>
                        {editAddress ? 'Edit' : 'Add'} {addressTypeLabel} Address
                    </DialogTitle>
                    <DialogActions>
                        <IconButton onClick={handleClose}>
                            <Close />
                        </IconButton>
                    </DialogActions>
                </Box>

                <Box component="form" onSubmit={formik.handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className='fw-bold input-label' variant='body2' gutterBottom>Contact Person</Typography>
                                {renderTextField('contactPerson', 'Contact Person')}
                            </Grid>

                            {/* <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className='fw-bold input-label' variant='body2' gutterBottom>Mobile Number</Typography>
                                {renderTextField('mobileNumber', 'Mobile Number', { slotProps: { htmlInput: { maxLength: 10 } } })}
                            </Grid> */}
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className='fw-bold input-label' variant='body2' gutterBottom>Mobile Number</Typography>
                                {renderTextField('mobileNumber', 'Mobile Number', {
                                    onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                                        formik.setFieldValue('mobileNumber', e.target.value.replace(/\D/g, '').slice(0, 10)),
                                    slotProps: { htmlInput: { maxLength: 10, inputMode: 'numeric', pattern: '[0-9]*' } },
                                })}
                            </Grid>

                            <Grid size={{ xs: 12 }}>
                                <Typography className='fw-bold input-label' variant='body2' gutterBottom>Address</Typography>
                                {renderTextField('addressLine1', 'Address', { multiline: true, rows: 2 })}
                            </Grid>

                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className='fw-bold input-label' variant='body2' gutterBottom>City</Typography>
                                {renderTextField('city', 'City')}
                            </Grid>

                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className='fw-bold input-label' variant='body2' gutterBottom>State</Typography>
                                {renderTextField('state', 'State')}
                            </Grid>

                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className='fw-bold input-label' variant='body2' gutterBottom>Country</Typography>
                                {renderTextField('country', 'Country')}
                            </Grid>

                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className='fw-bold input-label' variant='body2' gutterBottom>Postal Code</Typography>
                                {renderTextField('postalCode', 'Postal Code', { slotProps: { htmlInput: { maxLength: 6 } } })}
                            </Grid>

                            <Grid size={{ xs: 12 }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="isDefault"
                                            checked={formik.values.isDefault}
                                            onChange={formik.handleChange}
                                        />
                                    }
                                    label="Set as default address"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>

                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button variant="outlined" onClick={handleClose} className='btn-outlined-main'>
                            Cancel
                        </Button>
                        <Button type="submit" className='btn-main px-3'>
                            Save Address
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </Box>
    )
}

export default Address
